<app-content-container data-testid="admin-campaigns">
  <app-campaigns-banner [adminMode]="true" />

  @if (!campaignsStore.loading$()) {
    <div class="flex flex-col justify-center">
      <form class="flex items-center gap-4" data-testid="admin-campaigns-search-form" (ngSubmit)="onAdminSearch()">
        <mat-form-field class="custom-form !min-w-80">
          <input
            matInput
            placeholder="{{ 'shared.id' | translate }}"
            [(ngModel)]="adminSearchId"
            name="adminSearchId"
          />
        </mat-form-field>
        <mat-form-field class="custom-form !min-w-80">
          <input
            matInput
            placeholder="{{ 'shared.name' | translate }}"
            [(ngModel)]="adminSearchName"
            name="adminSearchName"
          />
        </mat-form-field>
        <button
          mat-flat-button
          color="primary"
          type="submit"
          data-testid="admin-campaigns-search-button"
          [disabled]="campaignsStore.loading$()"
        >
          @if (campaignsStore.loading$()) {
            <app-dots-spinner />
          } @else {
            {{ 'shared.search' | translate }}
          }
        </button>
      </form>
      <hr class="w-full my-6" />
    </div>
  } @else {
    <div class="flex flex-col justify-center">
      <div class="flex items-center gap-4">
        <div class="w-80 h-12">
          <ngx-skeleton-loader [theme]="{ width: '100%', height: '100%', 'border-radius': '100vw' }" />
        </div>
        <div class="w-80 h-12">
          <ngx-skeleton-loader [theme]="{ width: '100%', height: '100%', 'border-radius': '100vw' }" />
        </div>
        <div class="w-[132px] h-11">
          <ngx-skeleton-loader [theme]="{ width: '100%', height: '100%', 'border-radius': '100vw' }" />
        </div>
      </div>

      <hr class="w-full my-6" />
    </div>
  }

  @if (searchedOnce()) {
    <app-campaigns-datatable
      data-testid="admin-campaigns-datatable"
      [campaigns]="campaignsStore.campaigns$()"
      [campaignsLoading]="campaignsStore.campaignsLoading$()"
      [showCreateButton]="false"
      [adminMode]="true"
      [total]="campaignsStore.total$()"
      [requestFilters]="{ id: adminSearchId || undefined, name__ilike: adminSearchName || undefined }"
      (dataRefreshRequest)="onDataRefreshRequest($event)"
    />
  }
</app-content-container>
